import React, { useEffect, useState } from "react";
// recoil
import { useRecoilValue } from "recoil";
// react-router-dom
import { useLocation, useNavigate } from "react-router-dom";
// @Mui
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
// paths
import { PATH_DASHBOARD } from "src/routes/paths";
// hooks
import useLocales from "src/hooks/useLocales";
// atoms
import { fillFormStatusAtom } from "src/recoil";
//
import Iconify from "./Iconify";

// -------------------------------------------------------------------------------------

function FillFormNoticePopUp() {
  const fillFormStatus = useRecoilValue(fillFormStatusAtom);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  const { translate } = useLocales();

  useEffect(() => {
    setOpen(fillFormStatus.fill_form);
  }, [fillFormStatus]);

  if (pathname === PATH_DASHBOARD.algorithmForm && fillFormStatus.fill_form) {
    return <></>;
  }

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Stack alignItems="center" justifyContent="center">
          <Box component="img" src="/assets/waiting.png" sx={{ width: 300 }} />
          <Typography variant="h4" align="center">
            {translate(
              "componentsTranslations.fillFormNoticePopUpTranslations.title"
            )}
          </Typography>
          <Typography variant="subtitle1" align="center">
            {translate(
              "componentsTranslations.fillFormNoticePopUpTranslations.description"
            )}
          </Typography>
          <Button
            size="large"
            variant="contained"
            sx={{ mt: 4 }}
            onClick={() => navigate(PATH_DASHBOARD.algorithmForm)}
            endIcon={<Iconify icon="solar:alt-arrow-right-broken" />}
          >
            {translate(
              "componentsTranslations.fillFormNoticePopUpTranslations.action"
            )}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default FillFormNoticePopUp;
